<template>
  <div>
    <PageHeader title="การจัดส่งหนังสือ"></PageHeader>
    <b-container class="mt-5 px-5" fluid>
      <div class="card card-csq no-shadow">
        <div class="card-body search-section">
          <b-row>
            <b-col cols="4">
              <label><strong>รหัสนักเรียน</strong></label>
              <b-form-input
                v-model="studentId"
                type="text"
                class="form-control border-1"
                autofocus
                placeholder="ค้นหารหัสนักเรียน"
                @keydown="onlyNumbers"
              ></b-form-input>
            </b-col>
            <b-col cols="4">
              <label><strong>ชื่อผู้เรียน</strong></label>
              <b-form-input
                v-model="studentName"
                type="search"
                class="form-control border-1"
                autofocus
                placeholder="ค้นหาชื่อผู้เรียน"
              ></b-form-input>
            </b-col>
            <b-col cols="4">
              <label><strong>สถานะจัดส่งหนังสือ</strong></label>
              <b-form-select
                v-model="selectedStatus"
                :options="deliveryStatus"
              ></b-form-select>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4">
              <label><strong>รหัสชำระเงิน</strong></label>
              <b-form-input
                v-model="paymentCode"
                type="search"
                class="form-control border-1"
                autofocus
                placeholder="ค้นหารหัสชำระเงิน"
              ></b-form-input>
            </b-col>
            <b-col cols="4">
              <label><strong>ชื่อคอร์สเรียน</strong></label>
              <b-form-input
                v-model="courseName"
                type="search"
                class="form-control border-1"
                autofocus
                placeholder="ค้นหาชื่อคอร์สเรียน"
              ></b-form-input>
            </b-col>
            <b-col cols="4">
              <label><strong>วันที่ชำระเงิน</strong></label>
              <div class="date-range-field">
                <b-input-group>
                  <b-form-input
                    size="sm"
                    type="text"
                    :value="formattedPaymentDate"
                    placeholder="เลือกวันที่ชำระเงิน"
                    disabled
                  />
                  <b-input-group-prepend>
                    <b-button
                      size="sm"
                      variant="secondary"
                      @click="showCalendarRange('payment-date')"
                    >
                      <b-icon icon="calendar-range"></b-icon>
                    </b-button>
                  </b-input-group-prepend>
                </b-input-group>
                <DatePicker
                  v-model="paymentDate"
                  locale="th"
                  id="payment-date"
                  style="
                    display: none;
                    float: right;
                    position: relative;
                    will-change: transform;
                    left: 0px;
                  "
                  is-range
                />
              </div>
            </b-col>
          </b-row>
          <b-button
            @click="searchDeliveryInfo()"
            class="search-btn"
            block
            variant="primary"
          >
            ค้นหา
          </b-button>
        </div>
        <hr />
        <div class="card-body detail-section">
          <div class="header-section">
            <div class="action-section">
              <span>เลือกจำนวน {{ selectedStudentCount }} รายการ</span>
              <b-form-select
                v-model="selectedAction"
                :options="actionList"
                :disabled="!isStudentSelected"
              ></b-form-select>
              <b-button
                v-if="selectedAction === 'EXPORT'"
                @click="showExportBookListModal = true"
                variant="primary"
              >
                ยืนยัน
              </b-button>
            </div>
            <div>
              <b-button
                @click="generatePdf()"
                class="mr-2"
                variant="primary"
                :disabled="isDisableDownloadReportBtn"
              >
                <b-icon icon="chevron-double-down"></b-icon>
                ดาวน์โหลดรายงาน pdf
              </b-button>
              <b-button @click="showImportParcelModal = true" variant="dark">
                Import เลขพัสดุ
              </b-button>
            </div>
          </div>
          <b-table
            id="book-delivery-list"
            :fields="fields"
            :items="filterBookDeliveryList"
            :per-page="perPage"
            :current-page="currentPage"
            responsive
            style="font-size: 14px; border:hidden;"
            :busy="isLoading"
            hover
            striped
            show-empty
          >
            <template slot="table-busy" class="text-center text-danger my-2">
              <Loading />
            </template>
            <template #empty>
              <p class="text-center">ไม่มีข้อมูล</p>
            </template>
            <template #head(selected)>
              <b-form-checkbox
                v-model="allSelected"
                :indeterminate="indeterminate"
                @change="toggleAll"
              >
              </b-form-checkbox>
            </template>
            <template #cell(selected)="data">
              <b-form-checkbox
                v-model="data.item.isSelected"
                @change="checkIndeterminate"
              >
              </b-form-checkbox>
            </template>
            <template v-slot:cell(studentName)="data">
              <p>
                {{ data.item.mpStudentId || "-" }}
                <span v-if="data.item.mpAdminApproveAt">
                  <b-icon
                    icon="check-circle-fill"
                    :id="`tooltip-target-${data.index}`"
                    variant="success"
                  ></b-icon>

                  <b-tooltip
                    :target="`tooltip-target-${data.index}`"
                    triggers="hover"
                  >
                    วันที่ยืนยันตัวตน:
                    {{ data.item.mpAdminApproveAt | thaiDateTimeFilter }}
                  </b-tooltip>
                </span>
              </p>
              <p>{{ data.item.memberName }}</p>
            </template>
            <template v-slot:cell(paymentDate)="data">
              {{ data.item.coActualPurchaseDateTime | thaiDateTimeFilter }}
            </template>
            <template v-slot:cell(courseName)="data">
              <p>{{ data.item.cCourseCode || "-" }}</p>
              <p>{{ data.item.courseName || "-" }}</p>
            </template>
            <template v-slot:cell(bookName)="data">
              <p>{{ data.item.bookCode || "-" }}</p>
              <p>{{ data.item.bookName || "-" }}</p>
            </template>
            <template #cell(trackingId)="data">
              <b-form-input
                v-if="data.item.isEditing"
                v-model="data.item.bdTrackingId"
                @keyup.enter="saveRow(data.item)"
                size="sm"
              ></b-form-input>
              <span v-else>{{ data.item.bdTrackingId || "-" }}</span>
            </template>
            <template v-slot:cell(shippingDate)="data">
              <div v-if="data.item.isEditing" class="date-field">
                <b-input-group>
                  <b-form-input
                    size="sm"
                    type="text"
                    :value="formattedToThaiDate(data.item.bdTimestamp)"
                    placeholder="เลือกวันที่ส่ง"
                    disabled
                  />
                  <b-input-group-prepend>
                    <b-button
                      size="sm"
                      variant="secondary"
                      @click="showCalendarRange('shipping-date')"
                      @keydown.enter.prevent="saveRow(data.item)"
                    >
                      <b-icon icon="calendar-event"></b-icon>
                    </b-button>
                  </b-input-group-prepend>
                </b-input-group>
                <DatePicker
                  v-model="data.item.bdTimestamp"
                  locale="th"
                  id="shipping-date"
                  style="
                    display: none;
                    float: right;
                    position: relative;
                    will-change: transform;
                    left: 0px;
                  "
                />
              </div>
              <span v-else>{{ data.item.bdTimestamp | thaiDateFilter }}</span>
            </template>
            <template v-slot:cell(delivered)="data">
              <b-form-checkbox
                v-model="data.item.bdStatus"
                value="DELIVERED"
                unchecked-value="NOT_DELIVERED"
                :disabled="!data.item.isEditing"
                @keyup.enter.native="saveRow(data.item)"
              >
              </b-form-checkbox>
            </template>
            <template #cell(edited)="data">
              <div v-if="data.item.isEditing" class="d-flex shadow-sm">
                <b-button
                  variant="success"
                  size="sm"
                  @click="saveRow(data.item)"
                  :disabled="isInvalid(data.item)"
                  class="mr-1"
                >
                  <b-icon icon="save"></b-icon>
                </b-button>
                <b-button
                  variant="outline-danger"
                  size="sm"
                  @click="cancelEdit(data.item)"
                >
                  <b-icon icon="x"></b-icon>
                </b-button>
              </div>

              <b-button
                v-else
                @click="editRow(data.item)"
                variant="outline-warning"
                size="sm"
              >
                <b-icon icon="pencil-square"></b-icon>
              </b-button>
            </template>
          </b-table>
          <b-row class="mt-3" v-if="filterBookDeliveryList.length > 0">
            <b-col cols="6">
              <form class="form-inline">
                <div class="form-group mb-2">
                  <label>แสดง</label>
                </div>
                <div class="form-group ml-2 mb-2">
                  <b-form-select v-model="perPage" size="sm">
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                  </b-form-select>
                </div>
                <div class="form-group ml-2 mb-2">
                  <label>
                    จาก
                    {{ filterBookDeliveryList.length }}
                    รายการ
                  </label>
                </div>
              </form>
            </b-col>
            <b-col cols="6" v-if="filterBookDeliveryList.length > 0">
              <nav class="float-right">
                <b-pagination
                  v-model="currentPage"
                  :per-page="perPage"
                  :total-rows="filterBookDeliveryList.length"
                  aria-controls="book-delivery-list"
                  last-number
                >
                </b-pagination>
              </nav>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-container>

    <!-- export รายการส่งหนังสือ -->
    <b-modal
      v-model="showExportBookListModal"
      title="Export รายการส่งหนังสือ"
      size="xl"
      centered
      hide-footer
    >
      <div class="export-book-section">
        <div>
          <h5>{{ moment().format("DD/MM/YYYY") }}</h5>
          <p>
            นำออกทั้งหมด {{ bookSelectedExportList?.length }} รายการ | หนังสือ
            {{ totalBooks }} เล่ม
          </p>
        </div>
        <b-table
          id="export-book-list"
          :fields="exportBookFields"
          :items="bookSelectedExportList"
          responsive
          style="font-size: 14px; border:hidden;"
          hover
          show-empty
        >
          <template #empty>
            <p class="text-center">ไม่มีข้อมูล</p>
          </template>
          <template v-slot:cell(recipientName)="data">
            <p>
              {{ data.item?.memberName || "-" }}
            </p>
          </template>
          <template v-slot:cell(recipientAddress)="data">
            <p>{{ getAddress(data.item) }}</p>
          </template>
          <template v-slot:cell(remark)="data">
            <p>{{ data.item?.bookCode?.join(" | ") }}</p>
          </template>
        </b-table>
        <b-row class="mt-3" v-if="bookSelectedExportList.length > 0">
          <b-col cols="6">
            <form class="form-inline">
              <div class="form-group mb-2">
                <label>แสดง</label>
              </div>
              <div class="form-group ml-2 mb-2">
                <b-form-select v-model="bookExportPerPage" size="sm">
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                </b-form-select>
              </div>
              <div class="form-group ml-2 mb-2">
                <label>
                  จาก
                  {{ bookSelectedExportList.length }}
                  รายการ
                </label>
              </div>
            </form>
          </b-col>
          <b-col cols="6" v-if="bookSelectedExportList.length > 0">
            <nav class="float-right">
              <b-pagination
                v-model="bookExportCurrentPage"
                :per-page="bookExportPerPage"
                :total-rows="bookSelectedExportList.length"
                aria-controls="export-book-list"
                last-number
              >
              </b-pagination>
            </nav>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="button-group">
            <b-button
              variant="outline-primary"
              @click="showExportBookListModal = false"
            >
              ย้อนกลับ
            </b-button>
            <b-button
              @click="exportReport()"
              id="export-excel"
              variant="primary"
              href=""
              style="display: inline-block"
            >
              ยืนยัน
              <b-spinner
                id="export-excel-loading"
                class="align-middle mr-2"
                style="display: none"
                small
              ></b-spinner>
            </b-button>
            <ag-grid-vue
              style="width: 100%; height: 800px; display: none"
              class="ag-theme-alpine"
              :columnDefs="columnDefs"
              @grid-ready="onGridReady"
              :rowData="bookSelectedExportList"
              :excelStyles="excelStyles"
            ></ag-grid-vue>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal
      v-model="isShowExportBookSuccessModal"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
    >
      <div class="modal-approve-section">
        <b-icon
          icon="check-circle"
          variant="success"
          style="width: 80px; height: 80px;"
        ></b-icon>
        <h4>ส่งออกข้อมูลรายการส่งหนังสือสำเร็จ</h4>
        <b-button
          @click="isShowExportBookSuccessModal = false"
          variant="primary"
        >
          เสร็จสิ้น
        </b-button>
      </div>
    </b-modal>

    <!-- import เลขพัสดุ -->
    <b-modal
      v-model="showImportParcelModal"
      title="import เลขพัสดุ"
      size="xl"
      centered
      hide-footer
    >
      <ModalExamUpload modalType="parcel" @preview="previewParcelImport" />
    </b-modal>
    <b-modal
      v-model="showPacelPreviewModal"
      title="นำเข้าข้อมูลเลขพัสดุ"
      size="xl"
      centered
      hide-footer
    >
      <div class="export-book-section">
        <div>
          <h5>{{ new Date().toLocaleDateString() }}</h5>
          <p>
            นำออกทั้งหมด {{ parcelOrdersCount }} รายการ | หนังสือ
            {{ parcelPreview?.length }} เล่ม
          </p>
        </div>
        <b-table
          id="export-book-list"
          :fields="parcelPreviewFields"
          :items="parcelPreview"
          responsive
          style="font-size: 14px; border:hidden;"
          hover
          show-empty
        >
          <template #empty>
            <p class="text-center">ไม่มีข้อมูล</p>
          </template>

          <template v-slot:cell(delivered)="data">
            <b-form-checkbox
              v-model="data.item.bdStatus"
              value="DELIVERED"
              unchecked-value="NOT_DELIVERED"
            >
            </b-form-checkbox>
          </template>
          <template v-slot:cell(createdAt)="data">
            <p>{{ data.item.createdAt | thaiDateTimeFilter }}</p>
          </template>
          <template v-slot:cell(courseName)="data">
            <p>{{ data.item.cCourseCode || "-" }}</p>
            <p>{{ data.item.courseName || "-" }}</p>
          </template>
          <template v-slot:cell(bookName)="data">
            <p>{{ data.item.bookCode || "-" }}</p>
            <p>{{ data.item.bookName || "-" }}</p>
          </template>
        </b-table>
        <b-row class="mt-3" v-if="parcelPreview.length > 0">
          <b-col cols="6">
            <form class="form-inline">
              <div class="form-group mb-2">
                <label>แสดง</label>
              </div>
              <div class="form-group ml-2 mb-2">
                <b-form-select v-model="parcelPreviewPerPage" size="sm">
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                </b-form-select>
              </div>
              <div class="form-group ml-2 mb-2">
                <label>
                  จาก
                  {{ parcelPreview.length }}
                  รายการ
                </label>
              </div>
            </form>
          </b-col>
          <b-col cols="6" v-if="parcelPreview.length > 0">
            <nav class="float-right">
              <b-pagination
                v-model="parcelPreviewCurrentPage"
                :per-page="parcelPreviewPerPage"
                :total-rows="parcelPreview.length"
                aria-controls="export-book-list"
                last-number
              >
              </b-pagination>
            </nav>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="button-group">
            <b-button
              variant="outline-primary"
              @click="showPacelPreviewModal = false"
            >
              ย้อนกลับ
            </b-button>
            <b-button variant="primary" @click="importParcel()">
              ยืนยัน
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
    <b-modal
      v-model="isShowImportBookSuccessModal"
      centered
      hide-header
      hide-footer
      no-close-on-backdrop
    >
      <div class="modal-approve-section">
        <b-icon
          icon="check-circle"
          variant="success"
          style="width: 80px; height: 80px;"
        ></b-icon>
        <h4>นำเข้าข้อมูลเลขพัสดุสำเร็จ</h4>
        <b-button
          @click="isShowImportBookSuccessModal = false"
          variant="primary"
        >
          เสร็จสิ้น
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import PageHeader from "../../layouts/PageHeader";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import Loading from "@/components/shared/Loading";
import moment from "moment";
import dateMixin from "@/components/pages/analytics/shared/mixins/date.js";
import bookDeliveryReportMixin from "../../../mixins/book-delivery-report-mixin";
import generateAttendanceReportPdfMixin from "@/mixins/generate-attendance-report-pdf-mixin.js"; // Import Chart.js
import ModalExamUpload from "../exam-builder/modal/ModalExamUpload.vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import { AgGridVue } from "ag-grid-vue";
import { mapActions, mapGetters } from "vuex";

export default {
  mixins: [
    dateMixin,
    bookDeliveryReportMixin,
    generateAttendanceReportPdfMixin,
  ],
  components: {
    PageHeader,
    DatePicker,
    Loading,
    ModalExamUpload,
    "ag-grid-vue": AgGridVue,
  },
  computed: {
    ...mapGetters("BookManagement", ["bookDeliveryList", "parcelPreview"]),
    userInfo() {
      return JSON.parse(localStorage.getItem("user"));
    },
    filterBookDeliveryList() {
      const shippingInfo = this.bookDeliveryList.filter(
        (item) => item.bdType === "SHIPPING",
      );

      return shippingInfo;
    },
    currentProfile() {
      return this.getCurrentProfile(this.userInfo.profiles);
    },
    formattedPaymentDate() {
      return this.getFormattedRange(
        this.paymentDate.start,
        this.paymentDate.end,
        "payment-date",
      );
    },
    isStudentSelected() {
      return this.filterBookDeliveryList.some((item) => item.isSelected === true);
    },
    bookSelectedExportList() {
      const selected = this.filterBookDeliveryList.filter((item) => item.isSelected);
      return this.groupBookExportList(selected);
    },
    totalBooks() {
      return this.bookSelectedExportList.reduce(
        (sum, course) => sum + course.bookCode.length,
        0,
      );
    },
    parcelOrdersCount() {
      if (this.parcelPreview.length == 0) return "0";

      const ids = this.parcelPreview.map((order) => order.coOrderNumber);
      const uniqueIdsSet = new Set(ids);
      return uniqueIdsSet.size;
    },
    instituteName() {
      if (this.comId == 1000001) {
        return "สถาบันกวดวิชาเคมี อ.อุ๊";
      } else if (this.comId == 1000002) {
        return "สถาบันกวดวิชาแอพพลายด์ฟิสิกส์";
      } else if (this.comId == 1000003) {
        return "สถาบันกวดวิชาไบโอบีม";
      }
      return "-";
    },
  },
  data() {
    const currentDate = new Date();
    return {
      comId: this.$store.state.Company.companyInfo.id,
      moment: moment,
      studentId: null,
      studentName: "",
      paymentCode: null,
      courseName: "",
      deliveryStatus: [
        { value: "", text: "สถานะทั้งหมด" },
        { value: "DELIVERED", text: "จัดส่งแล้ว" },
        { value: "NOT_DELIVERED", text: "ยังไม่ได้จัดส่ง" },
      ],
      selectedStatus: "",
      paymentDate: {
        start: "",
        end: "",
      },
      selectedStudentCount: 0,
      selectedAction: "",
      actionList: [
        { value: "", text: "เลือกตัวเลือก" },
        { value: "EXPORT", text: "Export รายการส่งหนังสือ" },
      ],
      perPage: 10,
      currentPage: 1,
      bookExportPerPage: 10,
      bookExportCurrentPage: 1,
      parcelPreviewPerPage: 10,
      parcelPreviewCurrentPage: 1,
      isLoading: false,
      allSelected: false,
      indeterminate: false,
      originalData: null,
      showExportBookListModal: false,
      isShowExportBookSuccessModal: false,
      isShowImportBookSuccessModal: false,
      showImportParcelModal: false,
      showPacelPreviewModal: false,
      isDisableDownloadReportBtn: false,
      year: currentDate.getFullYear(),
      month: currentDate.getMonth() + 1,
      thaiMonths: [
        "มกราคม",
        "กุมภาพันธ์",
        "มีนาคม",
        "เมษายน",
        "พฤษภาคม",
        "มิถุนายน",
        "กรกฎาคม",
        "สิงหาคม",
        "กันยายน",
        "ตุลาคม",
        "พฤศจิกายน",
        "ธันวาคม",
      ],
      pdfOption: {
        orientation: "l",
        format: "a4",
        unit: "px",
        lineHeight: 1.5,
        putOnlyUsedFonts: true,
      },
      pdfConfig: {
        typo: {
          header: 16,
          large: 18,
          normal: 14,
          small: 12,
          extraSmall: 8,
          chartHeader: 18,
        },
        margin: {
          t: 40,
          b: 20,
          l: 20,
          r: 20,
          tChart: 10,
          tHeaderChart: 24,
          bHeaderTable: 5,
        },
        endNormal: 10,
        endRow: 18,
        endLegend: 32,
      },
      fields: [
        {
          label: "",
          key: "selected",
        },
        {
          label: "ชื่อผู้เรียน",
          key: "studentName",
        },
        {
          label: "วันที่ชำระเงิน",
          key: "paymentDate",
        },
        {
          label: "รหัสชำระเงิน",
          key: "coOrderNumber",
          thClass: "text-nowrap",
        },
        {
          label: "คอร์สเรียน",
          key: "courseName",
        },
        {
          label: "ชื่อหนังสือ",
          key: "bookName",
          thClass: "text-nowrap",
        },
        {
          label: "เลขพัสดุ",
          key: "trackingId",
        },
        {
          label: "วันที่ส่ง",
          key: "shippingDate",
        },
        {
          label: "ส่งแล้ว",
          key: "delivered",
          thClass: "text-nowrap",
        },
        {
          label: "",
          key: "edited",
        },
      ],
      exportBookFields: [
        {
          label: "รหัสชำระเงิน",
          key: "coOrderNumber",
          formatter: (value) => {
            return value || "-";
          },
        },
        {
          label: "ชื่อผู้รับ",
          key: "recipientName",
        },
        {
          label: "เบอร์ผู้รับ",
          key: "msaPhone",
          formatter: (value) => {
            return value || "-";
          },
        },
        {
          label: "ที่อยู่ที่รับ",
          key: "recipientAddress",
        },
        {
          label: "หมายเหตุ",
          key: "remark",
        },
      ],
      parcelPreviewFields: [
        {
          label: "ส่งแล้ว",
          key: "delivered",
        },
        {
          label: "เวลาสร้าง",
          key: "createdAt",
        },
        {
          label: "รหัสชำระเงิน",
          key: "coOrderNumber",
          thClass: "text-nowrap",
        },
        {
          label: "เลขพัสดุ",
          key: "trackingId",
        },
        {
          label: "ชื่อผู้รับ",
          key: "memberName",
        },
        {
          label: "เบอร์ผู้รับ",
          key: "phone",
        },
        {
          label: "คอร์สเรียน",
          key: "courseName",
        },
        {
          label: "ชื่อหนังสือ",
          key: "bookName",
          thClass: "text-nowrap",
        },
      ],
      gridApi: null,
      columnApi: null,
      excelStyles: [
        {
          id: "numberType",
          numberFormat: {
            format: "0",
          },
        },
        {
          id: "stringType",
          dataType: "String",
        },
        {
          id: "dateType",
          dataType: "DateTime",
        },
        {
          id: "dateISO",
          dataType: "DateTime",
          numberFormat: {
            format: "dd-mm-yyyy",
          },
        },
        {
          id: "header",
          font: { fontName: "Cordia New", size: 16, bold: true },
          alignment: {
            horizontal: "Center",
          },
        },
        {
          id: "cell",
          font: { fontName: "Cordia New", size: 16 },
          alignment: {
            horizontal: "Center",
          },
        },
        {
          id: "decimalFormat",
          numberFormat: {
            format: "#,##0.00",
          },
          alignment: {
            horizontal: "Right",
          },
        },
      ],
      columnDefs: [
        {
          headerName: "รายการส่งหนังสือ",
          children: [
            {
              headerName: "Customer_order_number \n (เลขออเดอร์ของลูกค้า)",
              field: "coOrderNumber",
              cellClass: "stringType",
            },
            {
              headerName: "*Consignee_name \n (ชื่อผู้รับ)",
              valueGetter: (params) => {
                return params.data?.memberName ?? "-";
              },
            },
            {
              headerName: "*Address \n (ที่อยู่)",
              valueGetter: (params) => {
                return this.getAddress(params.data);
              },
            },
            {
              headerName: "*Postal_code \n (รหัสไปรษณีย์)",
              field: "msaPostcode",
              cellClass: "stringType",
              valueGetter: (params) => {
                return params.data?.msaPostcode ?? "-";
              },
            },
            {
              headerName: "*Phone_number \n (เบอร์โทรศัพท์)",
              field: "msaPhone",
              cellClass: "stringType",
              valueGetter: (params) => {
                return params.data?.msaPhone ?? "-";
              },
            },
            { headerName: "Phone_number2 \n (เบอร์โทรศัพท์)", field: "" },
            { headerName: "Number of parcels \n（จำนวนพัสดุ）", field: "" },
            { headerName: "COD \n (ยอดเรียกเก็บ)", field: "" },
            {
              headerName: "Item description1(Name|Size/Weight|color|quantity)",
              field: "",
            },
            {
              headerName: "Item description2(Name|Size/Weight|color|quantity)",
              field: "",
            },
            {
              headerName: "Item description3(Name|Size/Weight|color|quantity)",
              field: "",
            },
            {
              headerName: "Item description4(Name|Size/Weight|color|quantity)",
              field: "",
            },
            {
              headerName: "Item description5(Name|Size/Weight|color|quantity)",
              field: "",
            },
            { headerName: "Item_type \n (ประเภทสินค้า)", field: "" },
            { headerName: "*Weight_kg \n (น้ำหนัก)", field: "" },
            { headerName: "Length \n (ยาว)", field: "" },
            { headerName: "Width \n (กว้าง)", field: "" },
            { headerName: "Height \n (สูง)", field: "" },
            {
              headerName: "Declared_value \n (มูลค่าสินค้าที่ระบุโดยลูกค้า)",
              field: "",
            },
            { headerName: "Box_shield", field: "" },
            {
              headerName: "Document return service \n (บริการส่งคืนเอกสาร)",
              field: "",
            },
            { headerName: "*Product_type \n (ประเภทสินค้า）", field: "" },
            { headerName: "*Payment method \n（วิธีชำระเงิน）", field: "" },
            {
              headerName: "Remark \n (หมายเหตุ)",
              field: "bookCode",
              valueGetter: (params) => {
                if (
                  params.data &&
                  params.data.bookCode &&
                  Array.isArray(params.data.bookCode)
                ) {
                  return params.data.bookCode.join("|");
                }
                return "";
              },
            },
          ],
        },
      ],
    };
  },
  mounted() {
    this.setDefaultDates();
    this.fetch({
      purchaseDateFrom: this.paymentDate.start,
      purchaseDateTo: this.paymentDate.end,
    });
  },
  methods: {
    ...mapActions("BookManagement", [
      "fetchBookDeliveryList",
      "updateBookDelivery",
      "updatePacelData",
    ]),
    async fetch(params) {
      this.isLoading = true;
      await this.fetchBookDeliveryList(params);
      this.isLoading = false;
    },
    searchDeliveryInfo() {
      let params = {
        studentId: this.studentId,
        memberName: this.studentName,
        bdStatus: this.selectedStatus,
        coOrderNumber: this.paymentCode,
        courseName: this.courseName,
        purchaseDateFrom: this.paymentDate.start
          ? moment(this.paymentDate.start).format("YYYY-MM-DD")
          : "",
        purchaseDateTo: this.paymentDate.end
          ? moment(this.paymentDate.end).format("YYYY-MM-DD")
          : "",
      };
      this.fetch(params);
    },
    getCurrentProfile(profiles) {
      const requestCompany = this.$route.params.company;
      if (requestCompany) {
        let currentCompany = profiles.find(
          (data) => data.company.url === requestCompany,
        );
        if (currentCompany) return currentCompany;
      } else if (localStorage.getItem("ComId")) {
        const currentComId = localStorage.getItem("ComId");
        let currentCompany = profiles.find(
          (data) => data.company.id == currentComId,
        );
        if (currentCompany) return currentCompany;
      }

      return profiles[0];
    },
    groupBookExportList(data) {
      const grouped = data.reduce((acc, current) => {
        const id = current.coOrderNumber;

        if (!acc[id]) {
          acc[id] = {
            ...current,
            bookCode: [current.bookCode],
            coPurchasePrice: [current.coPurchasePrice],
          };
        } else {
          acc[id].bookCode.push(current.bookCode);
          acc[id].coPurchasePrice.push(current.coPurchasePrice);
        }

        return acc;
      }, {});

      return Object.values(grouped);
    },
    exportReport() {
      document.getElementById("export-excel-loading").style.display =
        "inline-block";

      setTimeout(() => {
        this.gridApi.exportDataAsExcel({
          sheetName: "รายการส่งหนังสือ",
          fileName: `รายการส่งหนังสือ`,
        });
        document.getElementById("export-excel-loading").style.display = "none";
        this.showExportBookListModal = false;
        this.isShowExportBookSuccessModal = true;
      }, 1000);
    },
    async onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    async importParcel() {
      this.showPacelPreviewModal = false;
      let params = this.parcelPreview?.map((item) => {
        return {
          bdId: item.bdId,
          bdStatus: item.bdStatus,
          bdTrackingId: item.bdTrackingId,
        };
      });

      await this.updatePacelData(params);
      this.isShowImportBookSuccessModal = true;
      await this.fetch(null);
    },
    toggleAll(checked) {
      this.filterBookDeliveryList.forEach((item) => {
        this.$set(item, "isSelected", checked);
      });
      this.indeterminate = false;
    },
    checkIndeterminate() {
      const selectedCount = this.filterBookDeliveryList.filter((i) => i.isSelected)
        .length;
      if (selectedCount === 0) {
        this.indeterminate = false;
        this.allSelected = false;
      } else if (selectedCount === this.filterBookDeliveryList.length) {
        this.indeterminate = false;
        this.allSelected = true;
      } else {
        this.indeterminate = true;
        this.allSelected = false;
      }
    },
    editRow(item) {
      this.filterBookDeliveryList.forEach((i) => (i.isEditing = false));
      this.originalData = { ...item };
      this.$set(item, "isEditing", true);
    },
    async saveRow(item) {
      if (this.isInvalid(item)) return;

      let params = {
        bdId: item.bdId,
        attribute: {
          bdType: item.bdType,
          bdStatus: item.bdStatus,
          bdTrackingId: item.bdTrackingId,
          bdTimestamp: item.bdTimestamp,
        },
      };
      await this.updateBookDelivery(params);
      await this.fetch(null);
      this.$set(item, "isEditing", false);
    },
    cancelEdit(item) {
      Object.assign(item, this.originalData);
      this.$set(item, "isEditing", false);
    },
    previewParcelImport() {
      this.showImportParcelModal = false;
      this.showPacelPreviewModal = true;
    },
    isInvalid(item) {
      // Returns true (disabled) if either value is null or empty
      const hasNoTracking =
        item.bdTrackingId === null || item.bdTrackingId === "";
      const hasNoDate = item.bdTimestamp === null || item.bdTimestamp === "";

      return hasNoTracking || hasNoDate;
    },
    setDefaultDates() {
      const dateFormat = "YYYY-MM-DD";
      const currentDate = moment();
      const ninetyDaysAgo = moment(currentDate).subtract(90, "days");

      this.paymentDate.start = ninetyDaysAgo.format(dateFormat);
      this.paymentDate.end = currentDate.format(dateFormat);
    },
    showCalendarRange(calendarId) {
      let rangeCalendar = document.getElementById(calendarId);
      if (rangeCalendar.style.display == "inline-block") {
        rangeCalendar.style.display = "none";
      } else {
        rangeCalendar.style.display = "inline-block";
      }
    },
    getFormattedRange(startDate, endDate, calendarId) {
      if (!startDate) return "";

      const rangeCalendar = document.getElementById(calendarId);
      if (rangeCalendar && rangeCalendar.style.display === "inline-block") {
        this.showCalendarRange(calendarId);
      }

      const start = moment(startDate).format("DD/MM/YYYY");
      const end = moment(endDate).format("DD/MM/YYYY");
      return `${start} - ${end}`;
    },
    formattedToThaiDate(value) {
      if (!value) {
        return null;
      }
      return this.thaiDateFilter(moment(value).format("YYYY-MM-DD"));
    },
    formatDate(date) {
      if (!date) {
        return null;
      }

      return moment(date).format("YYYY-MM-DD");
    },
    getAddress(data) {
      if (!data) return "-";

      const {
        msaNumber,
        msaMoo,
        msaSoi,
        msaVillage,
        msaStreet,
        msaSubDistrict,
        msaDistrict,
        msaProvince,
        msaPostcode,
      } = data;

      const parts = [
        msaNumber,
        msaMoo ? `หมู่ ${msaMoo}` : null,
        msaSoi ? `ซอย ${msaSoi}` : null,
        msaVillage ? `หมู่บ้าน ${msaVillage}` : null,
        msaStreet ? `ถนน ${msaStreet}` : null,
        msaSubDistrict,
        msaDistrict,
        msaProvince,
        msaPostcode,
      ].filter(
        (val) => val !== null && val !== undefined && String(val).trim() !== "",
      );

      return parts.length > 0 ? parts.join(" ") : "-";
    },
    onlyNumbers(event) {
      const allowedKeys = [
        "Backspace",
        "Tab",
        "ArrowLeft",
        "ArrowRight",
        "Delete",
        "Enter",
      ];
      if (allowedKeys.includes(event.key)) return;

      if (!/^\d$/.test(event.key)) {
        event.preventDefault();
      }
    },
  },
};
</script>

<style>
.date-range-field .form-control,
.vs__dropdown-toggle {
  height: 38px;
}

.vs__dropdown-toggle {
  align-items: center;
}

.custom-select {
  height: 38px !important;
  padding: 0 1.75rem 0 0.75rem;
  font-size: 14px !important;
}
</style>

<style lang="scss" scoped>
.search-section {
  display: flex;
  flex-direction: column;
  gap: 24px;

  .date-range-field {
    width: 100%;
  }

  .search-btn {
    width: fit-content;
  }
}

.date-range-field,
.date-field {
  .form-control:disabled {
    background-color: #fff;
  }
}

.detail-section {
  display: flex;
  flex-direction: column;
  gap: 40px;

  .header-section {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .action-section {
      display: flex;
      align-items: baseline;
      gap: 15px;

      span {
        width: -webkit-fill-available;
      }
    }
  }
}

.export-book-section {
  display: flex;
  flex-direction: column;
  gap: 30px;

  .button-group {
    display: flex;
    justify-content: flex-end;
    gap: 10px;
  }
}

.modal-approve-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 30px;
  padding: 20px 0;
}

/* Calendar */
.vc-container {
  position: absolute !important;
  right: 0 !important;
  left: initial !important;
  margin-right: 13px;
  z-index: 99;
}

/* Target the input search and its placeholder */
::v-deep .vs__search,
::v-deep .vs__search::placeholder {
  margin: 0;
  padding: 3px 3px 2px;
  font-size: 14px;
}
</style>
